<template style="height: 100%;">
  <div class="ReportDataMater-gray">
    <el-container>
      <el-header class="RDMater-gray-header">
        <el-form :model="ruleForm" ref="ruleForm" :inline="true" style="
            margin: 20px 0px;
            background: rgba(245, 247, 250, 1);
            padding: 10px;
            overflow: hidden;
            height: 42px;
          ">
          <el-form-item label="学号">
            <!-- <el-form-item :label="$t('original.account')"> -->
            <el-input placeholder="请输入学号" v-model="ruleForm.UserID"></el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input placeholder="请输入姓名" v-model="ruleForm.UserName"></el-input>
          </el-form-item>
          <el-form-item label="关注状态">
            <el-select placeholder="请选择关注状态" v-model="CareSelect">
              <el-option v-for="oitem in CareList" :key="oitem.AnswerName" :label="oitem.AnswerName"
                :value="oitem.AnswerName"></el-option>
            </el-select>
          </el-form-item>
          <div class="RDMaster-Query-Option">
            <el-button type="primary" @click="resetForm()">
              重置
            </el-button>
            <el-button type="primary" @click="onSelect()">查询</el-button>
            <el-button type="primary" @click="addUser" v-if="MenuControl == -1">添加学生</el-button>
            <el-button type="primary" @click="batAddUser" v-if="MenuControl == -1">批量添加学生</el-button>
            <el-button type="primary" @click="ViewStatistics" v-if="MenuControl == -1">查看统计</el-button>
          </div>
        </el-form>
      </el-header>
      <el-main class="RDMater-gray-main">
        <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading" :data="tableData" tooltip-effect="dark" style="width: 100%;">
          <el-table-column label="序号" min-width="6%" align="center">
            <template slot-scope="scope">
              {{ (currentPage - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="UserID"
            :label="$t('original.account')"
            min-width="10%"
            align="center"
          ></el-table-column> -->
          <el-table-column prop="UserID" label="学号" min-width="10%" align="center"></el-table-column>
          <el-table-column prop="RealName" label="姓名" min-width="10%" align="center"></el-table-column>
          <el-table-column prop="Sex" label="性别" min-width="10%" align="center"></el-table-column>
          <el-table-column label="关注状态" min-width="10%" align="center">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.CareColor }">
                {{ scope.row.CareState }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="HeartTalkTime" label="访谈者评估时间" min-width="10%" align="center"></el-table-column>
          <el-table-column prop="PsyTalkTime" label="心理排查时间" min-width="10%" align="center"></el-table-column>
          <el-table-column prop="TalkEvalTime" label="心理精神障碍评估时间" min-width="10%" align="center"></el-table-column>
          <el-table-column prop="CreatedTime" label="创建时间" min-width="10%" align="center"></el-table-column>
          <el-table-column label="操作" min-width="15%" align="center">
            <template slot-scope="scope">
              <span @click="
  dialoginfoVisible = true;
GoToReportData(scope.row);
              " class="rp-table_btn" v-if="MenuControl == -1">
                上报数据
              </span>
              <span @click="
  dialoginfoVisible = true;
GoToReportData(scope.row);
              " class="rp-table_btn" v-if="MenuControl == -2">
                查看信息
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="tableData.length > 0">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="10"
            layout="total, prev, pager, next" :total="RecordCount">
          </el-pagination>
        </div>
      </el-main>
    </el-container>

    <el-dialog title="添加学生" :visible.sync="dialogVisible" :close-on-click-modal="false" width="900px">
      <div class="dialog-content" :style="{ height: dialogHeight }">
        <table>
          <tr>
            <th colspan="2" class="dialog-second-title">基本信息</th>
          </tr>
          <tr>
            <td class="dialog-title">
              <span class="must-tip">*</span>
              学号
            </td>
            <td>
              <el-input v-model="UserInfo.UserID" @change="GetAccountInput(UserInfo.UserID)" maxlength="20"></el-input>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">
              <span class="must-tip">*</span>
              姓名
            </td>
            <td>
              <el-input v-model="UserInfo.RealName" maxlength="50"></el-input>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">
              <span class="must-tip">*</span>身份证号
            </td>
            <td>
              <el-input v-model="UserInfo.IDCard" maxlength="18" @blur="HandleIDCard()"></el-input>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">
              <span class="must-tip">*</span>
              性别
            </td>
            <td>
              <el-radio v-model="UserInfo.Sex" label="1">男</el-radio>
              <el-radio v-model="UserInfo.Sex" label="0">女</el-radio>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">
              <span class="must-tip">*</span>
              出生日期
            </td>
            <td>
              <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="UserInfo.Birthday"
                :picker-options="pickerOptions"></el-date-picker>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">
              <span class="must-tip">*</span>
              个人电话号码
            </td>
            <td>
              <el-input v-model="UserInfo.Phone" maxlength="20"></el-input>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">
              <span class="must-tip">*</span>
              学院
            </td>
            <td>
              <el-cascader class="dialog-cascader" ref="wcascader" v-model="UserInfo.Classed" @expand-change="bumen"
                @change="DeptIDChange" :options="DeptData" :props="{ checkStrictly: true }" clearable></el-cascader>
            </td>
          </tr>
          <tr>
            <td class="dialog-title"><span class="must-tip">*</span>专业</td>
            <td>
              <el-select v-model="UserInfo.SpecialtyID" placeholder="请选择专业" @change="ClassSelect">
                <el-option v-for="(item, index) in SpecialtyList" :label="item.label" :value="item.value"
                  v-bind:key="index">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="dialog-title"><span class="must-tip">*</span>班级</td>
            <td>
              <el-select v-model="UserInfo.DeptID" placeholder="请选择班级">
                <el-option v-for="(item, index) in ClassList" :label="item.label" :value="item.value"
                  v-bind:key="index">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">入学年份</td>
            <td>
              <el-select v-model="UserInfo.TheEntranceDate" placeholder="请选择入学年份">
                <el-option :label="item" :value="item" v-for="(item, index) in YearList" v-bind:key="index"></el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">年级</td>
            <td>
              <el-select v-model="UserInfo.EntryDate" placeholder="请选择年级">
                <el-option :label="item.CDicValue" :value="item.CDicValue" v-for="(item, index) in GradeList"
                  v-bind:key="index"></el-option>
              </el-select>
            </td>
          </tr>

          <tr>
            <td class="dialog-title">监护人姓名</td>
            <td>
              <el-input v-model="UserInfo.TheGuardian" maxlength="20"></el-input>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">监护人电话号码</td>
            <td>
              <el-input v-model="UserInfo.TheGuardianPhone" maxlength="20"></el-input>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">监护人身份</td>
            <td>
              <el-select v-model="UserInfo.TheGuardianRelationShip" placeholder="请选择监护人身份">
                <el-option :label="item.CDicValue" :value="item.DicKey" v-for="(item, index) in RelativeList"
                  v-bind:key="index"></el-option>
              </el-select>
              <el-input v-model="UserInfo.Bak19" maxlength="20"
                v-if="UserInfo.TheGuardianRelationShip == '其他'"></el-input>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">学生类型</td>
            <td>
              <el-select v-model="UserInfo.Degree" placeholder="请选择学生类型">
                <el-option :label="item.CDicValue" :value="item.CDicValue" v-for="(item, index) in DegreeList"
                  v-bind:key="index"></el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">是否是贫困生</td>
            <td>
              <el-select v-model="UserInfo.Bak20" placeholder="请选择是否是贫困生">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">生源地</td>
            <td>
              <el-cascader ref="myProvinCas" v-model="UserInfo.NativePlaceList" placeholder="省/市/区" :options="PlaceList"
                :props="{ value: 'label' }"></el-cascader>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">民族</td>
            <td>
              <el-select v-model="UserInfo.Nation" placeholder="请选择民族">
                <el-option :label="item.CDicValue" :value="item.DicKey" v-for="(item, index) in NationList"
                  v-bind:key="index"></el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">国籍</td>
            <td>
              <el-select v-model="UserInfo.Nationality" placeholder="请选择国籍">
                <el-option :label="item.CDicValue" :value="item.DicKey" v-for="(item, index) in NationalityList"
                  v-bind:key="index"></el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="dialog-title">学籍异动</td>
            <td>
              <el-select v-model="UserInfo.Bak18" placeholder="请选择学籍异动">
                <el-option :label="item.CDicValue" :value="item.CDicValue" v-for="(item, index) in StudentList"
                  v-bind:key="index"></el-option>
              </el-select>
            </td>
          </tr>
        </table>

        <div class="dialog-option">
          <el-button type="primary" @click="submitForm">
            保存
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog v-loading="loadingExcel" element-loading-text="上传中..." element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)" title="批量导入" :visible.sync="dialogExcelVisible" width="30%;"
      height="50%" :before-close="handleClose">
      <div class="upLoadFileDialogContent" v-if="uploadUserList.length === 0">
        <div class="down_template" @click="down_template">
          <i class="el-icon-download"></i>
          <span>下载模板</span>
        </div>

        <div class="up_template">
          <el-upload drag ref="upload" :limit="limitNum" :auto-upload="false" accept=".xls,.xlsx" :action="UploadUrl()"
            :on-remove="handleRemove" :before-upload="beforeUploadFile" :on-change="fileChange"
            :on-success="handleSuccess" :on-error="handleError" :file-list="fileList" :on-exceed="exceedFile">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传xlsx,xls文件，且不超过10M
            </div>
          </el-upload>
        </div>
      </div>
      <div class="upLoadDialogContent" :style="{ height: winHeight + 'px' }" v-else>
        <el-table ref="multipleUserTable" element-loading-spinner="el-icon-loading" :data="uploadUserList"
          :row-class-name="tableRowClassName" tooltip-effect="dark"
          style="width: 100%;height: calc(100% - 74px); overflow: auto;">
          <el-table-column label="序号" width="50" align="center">
            <template slot-scope="scope">
              <span>
                {{ scope.$index + 1 }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="学号" :label="$t('original.account')" width="120" align="center"></el-table-column>
          <el-table-column prop="姓名" label="姓名" width="150" align="center"></el-table-column>
          <el-table-column prop="身份证号" label="身份证号" width="200" align="center"></el-table-column>
          <el-table-column prop="性别" label="性别" width="50" align="center"></el-table-column>
          <el-table-column prop="出生日期" label="出生日期" width="100" align="center"></el-table-column>
          <el-table-column prop="个人电话号码" label="个人电话号码" width="120" align="center"></el-table-column>
          <el-table-column prop="学院" label="学院" width="120" align="center"></el-table-column>
          <el-table-column prop="专业" label="专业" width="120" align="center"></el-table-column>
          <el-table-column prop="班级" label="班级" width="120" align="center"></el-table-column>
          <el-table-column prop="入学年份" label="入学年份" width="80" align="center"></el-table-column>
          <el-table-column prop="年级" label="年级" width="80" align="center"></el-table-column>
          <el-table-column prop="监护人姓名" label="监护人姓名" width="100" align="center"></el-table-column>
          <el-table-column prop="监护人电话号码" label="监护人电话号码" width="120" align="center"></el-table-column>
          <el-table-column prop="监护人身份" label="监护人身份" width="100" align="center"></el-table-column>
          <el-table-column prop="学生类型" label="学生类型" width="80" align="center"></el-table-column>
          <el-table-column prop="是否是贫困生" label="是否是贫困生" width="120" align="center"></el-table-column>
          <el-table-column prop="生源地" label="生源地" width="150" align="center"></el-table-column>
          <el-table-column prop="民族" label="民族" width="100" align="center"></el-table-column>
          <el-table-column prop="国籍" label="国籍" width="80" align="center"></el-table-column>
          <el-table-column prop="学籍异动" label="学籍异动" width="100" align="center"></el-table-column>
          <el-table-column label="是否错误" width="100" align="center">
            <template slot-scope="scope">
              <span :style="{
                color: parseInt(scope.row.RowState) == 1 ? '#606266' : 'red',
              }">
                {{ parseInt(scope.row.RowState) == 1 ? '有效' : '无效' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="Msg" label="错误信息" width="150" align="center"></el-table-column>
        </el-table>

        <div class="upload-footer">
          <el-button @click="closeUpLoadDialog">取 消</el-button>
          <el-button type="primary" @click="uploadUserFile">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { regionData } from 'element-china-area-data';
import internal from 'stream';

export default {
  data() {
    return {
      lang: '',
      MenuID: '',
      MenuControl: -1,
      loading: false,
      dialogHeight: '500px',
      winHeight: '300px', //实时屏幕高度
      pageIndex: 0,
      pageSize: 10,
      RecordCount: 0,
      tableData: [],
      currentPage: 1,
      ruleForm: {
        UserID: '',
        UserName: '',
        UserTime: null,
      },
      UserInfo: {
        DeptID: '',
        UserID: '',
        RealName: '',
        UserTime: null,
        Sex: '',
        Birthday: '',
        Classed: '',
        Specialty: '',
        SpecialtyID: '',
      },
      dialogVisible: false,
      dialogExcelVisible: false,
      limitNum: 1, // 上传excell时，同时允许上传的最大数
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 3600 * 1000 * 24 + 8.64e7;
        },
      },
      SpecialtyList: [],
      StudentList: [],
      ClassList: [],
      PlaceList: regionData,
      CareSelect: '',
      CareList: [],
      YearList: [],
      TableConfig: {},
      DeptData: [],
      GradeList: [],
      DegreeList: [],
      NationList: [],
      NationalityList: [],
      RelativeList: [],
      loadingExcel: false,
      fileList: [],
      uploadUserList: [],
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (parseInt(row.RowState) == 0) {
        return 'dialog-data-wrong';
      }
    },
    init: function (pIndex) {
      let parm = {
        PageIndex: pIndex,
        PageSize: this.pageSize,
        Account: this.ruleForm.UserID,
        Name: this.ruleForm.UserName,
        CareState: this.CareSelect,
      };
      this.$Http_Post('ReportCriData/GetReportDataUserList', parm)
        .then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.tableData = res.Data;
            this.RecordCount = Number(res.Counts);
          } else {
            this.Global.request_failure(res.Message);
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          });
        });
    },
    handleRemove() {
      this.$refs.upload.clearFiles();
      this.fileList = [];
    },
    onSelect: function () {
      this.pageIndex = 0;
      this.init(1);
    },
    DeptIDChange() {
      let _this = this;
      if (_this.UserInfo.Classed.length > 1) {
        this.$Http_Post('/DepartMent/GetDeprtMentByNodeAdd', {
          DeptID: _this.UserInfo.Classed[_this.UserInfo.Classed.length - 1],
          content: '',
          DeptType: 3,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            _this.SpecialtyList = [];

            if (res.Data.length > 0) {
              for (let index = 0; index < res.Data.length; index++) {
                let key = {
                  value: res.Data[index].value,
                  label: res.Data[index].label,
                };

                _this.SpecialtyList.push(key);
              }
            }
          }
        });
      }
    },
    ClassSelect() {
      let _this = this;
      _this.UserInfo.DeptID = '';
      _this
        .$Http_Post('/DepartMent/GetDeprtMentByNodeAdd', {
          DeptID: this.UserInfo.SpecialtyID,
          content: '',
          DeptType: 4,
        })
        .then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            _this.ClassList = [];
            if (res.Data.length > 0) {
              for (let index = 0; index < res.Data.length; index++) {
                let key = {
                  value: res.Data[index].value,
                  label: res.Data[index].label,
                };
                _this.ClassList.push(key);
              }
            }
          }
        });
    },

    handleClose(done) {
      if (this.fileList.length > 0 || this.uploadUserList.length > 0) {
        this.$confirm('确认关闭？')
          .then((_) => {
            this.fileList = [];
            this.uploadUserList = [];
            done();
          })
          .catch((_) => { });
      } else done();
    },
    down_template() {
      let _this = this;
      this.$Http_Post('ReportCriData/HandleUserUploadFile').then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location.replace(this.Global.ApiUrl + res.Data);
        }
      });
    },
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {
      //this.fileList=file;
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== 'xlsx' || extension !== 'xls') {
        this.$message.warning('只能上传后缀是.xlsx,xls的文件');
      }
      if (size > 1) {
        this.$message.warning('文件大小不得超过1M');
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      this.$message.success('文件上传成功');
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$message.error('文件上传失败');
    },
    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$message.closeAll();
      this.$message.warning(
        `只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length +
        fileList.length} 个`
      );
    },
    UploadUrl: function () {
      if (this.fileList.length > 0) {
        this.loadingloadingExcelsss = true;
        var fd = new FormData();
        fd.append('file', this.fileList[0]);
        fd.append('userType', '1058');
        let _this = this;
        this.$Http_Post('ReportCriData/UploadUserFile', fd).then((res) => {
          _this.loadingloadingExcelsss = false;
          this.$refs.upload.clearFiles();
          _this.fileList = [];
          if (res.Code == 200 || res.Code == 0) {
            _this.uploadUserList = res.Data;
          } else this.Global.request_failure(res.Message);
        });
      }
    },
    uploadUserFile() {
      if (this.uploadUserList.length > 0) {
        if (this.CheckUserListState()) {
          let _this = this;
          this.$Http_Post('ReportCriData/SaveUserList', {
            Data: this.uploadUserList,
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful('保存成功！');
              _this.uploadUserList = [];
              _this.pageIndex = 0;
              _this.dialogExcelVisible = false;
              _this.init(1);
            } else {
              this.Global.request_failure(res.Message);
            }
          });
        } else this.Global.request_failure('请修正错误数据后再进行导入');
      }
    },
    CheckUserListState: function () {
      let result = true;
      for (let i = 0; i < this.uploadUserList.length; i++) {
        if (parseInt(this.uploadUserList[i].RowState) == 0) {
          result = false;
          break;
        }
      }
      return result;
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      this.fileList.push(file.raw);
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init(val);
    },
    resetForm: function () {
      this.pageIndex = 0;
      this.ruleForm.UserID = '';
      this.ruleForm.UserName = '';
      this.CareSelect = '';
      this.init(1);
    },
    addUser: function () {
      this.dialogVisible = true;
    },
    batAddUser: function () {
      this.dialogExcelVisible = true;
    },
    ViewStatistics: function () {
      //this.$router.push('/ReportData/RPStatistics');
      window.open('/ReportData/RPStatistics', '_blank');
    },
    GetAccountInput: function (uid) {
      if (uid && uid != '') {
        this.$Http_Post('ReportCriData/GetUserInfoByUserID', { UserID: uid })
          .then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              if (res.Data != null) this.UserInfo = res.Data;
            } else {
              this.Global.request_failure(res.Message);
            }
          })
          .catch((err) => {
            this.$message({
              type: 'error',
              message: err.message,
            });
          });
      }
    },
    HandleIDCard: function () {
      if (this.UserInfo.IDCard != undefined && this.UserInfo.IDCard != '') {
        if (!this.Global.isCardID(this.UserInfo.IDCard)) {
          this.Global.request_failure('身份证格式错误');
          this.UserInfo.Sex = '';
          this.UserInfo.Birthday = '';
        } else {
          let birthDay = '';
          if (this.UserInfo.IDCard.length == 15) {
            birthDay = '19' + this.UserInfo.IDCard.slice(6, 12);
          } else if (this.UserInfo.IDCard.length == 18) {
            birthDay = this.UserInfo.IDCard.slice(6, 14);
          }
          if (parseInt(this.UserInfo.IDCard.slice(-2, -1)) % 2 == 1) {
            this.UserInfo.Sex = '1';
          } else {
            this.UserInfo.Sex = '0';
          }
          this.UserInfo.Birthday = birthDay.replace(/(.{4})(.{2})/, '$1-$2-');
        }
      }
    },
    submitForm: function () {
      if (this.UserInfo.UserID == '') {
        this.Global.request_info('请填写学号');
      } else if (this.UserInfo.RealName == '') {
        this.Global.request_info('请填写姓名');
      } else if (this.UserInfo.RealName == '') {
        this.Global.request_failure('请输入姓名');
      } else if (this.UserInfo.IDCard == '') {
        this.Global.request_failure('请输入身份证号');
      } else if (this.UserInfo.Sex == undefined || this.UserInfo.Sex == '') {
        this.Global.request_info('请选择性别');
      } else if (
        this.UserInfo.Birthday == undefined ||
        this.UserInfo.Birthday == ''
      ) {
        this.Global.request_info('请填写出生日期');
      } else if (
        this.UserInfo.Phone == undefined ||
        this.UserInfo.Phone == ''
      ) {
        this.Global.request_info('请填写个人电话号码');
      } else if (
        this.UserInfo.Classed == undefined ||
        this.UserInfo.Classed == ''
      ) {
        this.Global.request_info('请选择学院');
      } else if (
        this.UserInfo.SpecialtyID == undefined ||
        this.UserInfo.SpecialtyID == ''
      ) {
        this.Global.request_info('请选择专业');
      } else if (
        this.UserInfo.DeptID == undefined ||
        this.UserInfo.DeptID == ''
      ) {
        this.Global.request_info('请选择班级');
      } else {
        let _this = this;
        if (this.CheckSumDataState()) {
          for (let i = 0; i < _this.RelativeList.length; i++) {
            if (
              _this.RelativeList[i].CDicValue ==
              _this.UserInfo.TheGuardianRelationShip
            ) {
              _this.UserInfo.TheGuardianRelationShip =
                _this.RelativeList[i].DicKey;
              break;
            }
          }
          for (let i = 0; i < _this.SpecialtyList.length; i++) {
            if (_this.SpecialtyList[i].value == _this.UserInfo.SpecialtyID) {
              _this.UserInfo.Specialty = _this.SpecialtyList[i].label;
              break;
            }
          }
          this.$Http_Post('ReportCriData/AddUserInfo', _this.UserInfo)
            .then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.Global.request_successful('保存成功！');
                setTimeout((result) => {
                  _this.dialogVisible = false;
                  _this.UserInfo = {
                    UserID: '',
                    RealName: '',
                    UserTime: null,
                  };
                  _this.init(1);
                }, 2000);
              } else {
                this.Global.request_failure(res.Message);
              }
            })
            .catch((err) => {
              this.$message({
                type: 'error',
                message: err.message,
              });
            });
        }
      }
    },
    CheckSumDataState() {
      let result = true;
      if (this.UserInfo.UserID == '') {
        result = false;
        this.Global.request_failure('请输入学号');
      } else if (this.UserInfo.RealName == '') {
        result = false;
        this.Global.request_failure('请输入姓名');
      } else if (
        this.UserInfo.IDCard == undefined ||
        this.UserInfo.IDCard == ''
      ) {
        result = false;
        this.Global.request_failure('请输入身份证号');
      } else if (!this.Global.isCardID(this.UserInfo.IDCard)) {
        result = false;
        this.Global.request_failure('身份证格式错误');
      } else if (
        this.UserInfo.Phone != undefined &&
        this.UserInfo.Phone != '' &&
        !this.Global.checkMobile(this.UserInfo.Phone)
      ) {
        result = false;
        this.Global.request_failure('个人电话号码格式错误');
      }
      return result;
    },
    GoToReportData(item) {
      this.$router.push({
        path: '/ReportData/RPDataReportMaster',
        query: {
          MenuID: this.MenuID,
          TRPUserID: item.TRPUserID,
          UserID: item.UserID,
          Control: this.MenuControl,
        },
      });
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break;
        } else if (
          NodeList[i].fuzi &&
          NodeList[i].children.length > 0 &&
          NodeList[i].children[0].DeptID != '-1'
        ) {
          this.GetNodeByDeptID(ID, NodeList[i].children);
        }
      }
      return obj;
    },
    bumen(dt) {
      this.UserInfo.SpecialtyID = '';
      this.UserInfo.DeptID = '';
      let obj = this.DeptData[0];
      for (let i = 0; i < this.DeptData.length; i++) {
        if (this.DeptData[i].DeptID == dt[dt.length - 1]) {
          obj = this.DeptData[i];
          break;
        } else if (
          this.DeptData[i].fuzi &&
          this.DeptData[i].children.length > 0 &&
          this.DeptData[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.DeptData[i].children
          );
        }
      }

      let _this = this;
      if (
        obj.fuzi &&
        obj.children.length > 0 &&
        obj.children[0].DeptID == '-1'
      ) {
        obj.children = [{ label: '数据加载中...' }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNodeAdd', {
          DeptID: dt[dt.length - 1],
          content: '',
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        });
      }
    },
    closeUpLoadDialog: function () {
      this.uploadUserList = [];
    },
  },
  mounted() {
    this.MenuID = this.$route.query.MenuID;
    this.MenuControl = this.$route.query.Control;
    this.winHeight = document.documentElement.clientHeight * 0.5;
    this.$nextTick(function () {
      this.dialogHeight =
        (document.documentElement.clientHeight * 0.65).toString() + 'px';
    });
    let _this = this;
    let nowYear = new Date().getFullYear();
    for (let i = 0; i < 10; i++) {
      this.YearList.push(nowYear - i);
    }
    this.$Http_Post('User/GetDicListByDicTypeCode', {
      DicTypeList: 'GradeLevel,Degree,Nation,Nationality,Relative,Student',
    })
      .then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.GradeList = res.Data[0];
          _this.DegreeList = res.Data[1];
          _this.NationList = res.Data[2];
          _this.NationalityList = res.Data[3];
          _this.RelativeList = res.Data[4];
          _this.StudentList = res.Data[5];
        } else {
          this.Global.request_failure(res.Message);
        }
      })
      .catch((err) => {
        this.Global.request_failure(res.Message);
      });
    this.$Http_Post('ReportCriData/GetAnswerItemListByItemID', {
      TBCItemID: 'IER06',
    })
      .then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.CareList = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
      .catch((err) => {
        this.Global.request_failure(res.Message);
      });
    this.$Http_Post('/DepartMent/GetDeprtMentByNodeAdd', {
      DeptID: '',
      content: '',
    }).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        _this.DeptData = res.Data;
      }
    });
    this.init(1);
  },
};
</script>
<style>
.upLoadFileDialogContent {
  text-align: center;
}

.upLoadDialogContent {
  width: 100%;
  overflow: auto;
  box-shadow: 0px 0px 5px rgb(172, 169, 169);
  position: relative;
}

.upload-footer {
  position: sticky;
  bottom: 15px;
  width: 100%;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.dialog-data-wrong td {
  background-color: rgb(233, 212, 180);
  color: red;
}

.down_template {
  text-decoration: underline;
  color: rgb(19, 109, 226);
  cursor: pointer;
}
</style>
